import React, { useState, useEffect, useContext } from 'react'
import { MDBInput, MDBContainer } from 'mdbreact';
import axios from 'axios'
import { errores } from '../hooks/Funciones'
import moment from 'moment'
import VerInteracciones from './VerInteracciones'
import VerCampanasCliente from './VerCampanasCliente'

import ReactMoment from 'react-moment';
import { jsonrepair } from 'jsonrepair';
import { parseJSON } from 'date-fns';
import Cookies from 'universal-cookie';


const getRandomInt = (max) => {
	return Math.floor(Math.random() * max);
}

const VerCliente = ({ baseUrl, data, setData, setFuncion, Cursos, funcion, registroSelect, urlAsesores, urlCampanas, setDataFiltrado, urlEstados, urlInteracciones, urlPedidosCliente, urlProductos, peticionTraeDatos }) => {
	//errores
	const cookies = new Cookies()
	const [error, setError] = useState({ activo: '' })
	const [claveNueva, setClaveNueva] = useState('')
	const [estados, setEstados] = useState([])
	const [asesores, setAsesores] = useState([])
	const [interacciones, setInteracciones] = useState([])
	const [pedidos, setPedidos] = useState([])
	const [campanas, setCampanas] = useState([])
	const [cursosPedidos, setCursosPedidos] = useState([])

	const [documentos, setDocumentos] = useState({
		documentos: false,
		licencia: false,
		fotocopiasid: false,
		fotocopiasbachiller: false,
		fotocopiasnotariada: false,
		documentomedico: false,
		citasenviadas: false,
		usuariopass: false,
		usuariopass: false
	})

	const handleCheckboxChange = (e) => {
		const { name, checked } = e.target;
		setDocumentos(prevEstado => ({
			...prevEstado,
			[name]: checked
		}));
	};

	const [registro, setRegistro] = useState(
		funcion === 'editar' ?
			{ ...registroSelect, tel: registroSelect.telefono, cursos: registroSelect?.cursos ? JSON.parse(registroSelect?.cursos) : [], nota_crm: '' } :
			{ cursos: [], fecha_cad: moment(new Date()).format("YYYY-MM-DD"), activo: 'Aprobado', nota_crm: '' }
	)

	const [cursosActuales, setCursosActuales] = useState([])

	const peticionTraeEstados = () => {
		axios.get(urlEstados)
			.then(response => {
				setEstados(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	const peticionTraeCampanas = () => {
		axios.get(urlCampanas, { params: { id_cliente: registro.id } })
			.then(response => {
				setCampanas(response.data)
			}).catch(error => {
				console.log(error)
			})

	}

	const peticionTraeAsesores = () => {
		axios.get(urlAsesores)
			.then(response => {
				setAsesores(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	const peticionTraeInteracciones = () => {
		axios.get(urlInteracciones, { params: { id_cliente: registro.id } })
			.then(response => {
				setInteracciones(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	const peticionTraePedidos = async () => {
		try {
			if (!registro?.usuario) return null;

			const { data } = await axios.get(urlPedidosCliente, { params: { cliente: registro.usuario } });
			const array = data.map(item => ({
				id: item.id, tipo: item.tipo,
				fecha: item.fecha,
				total: item.total,
				canal: item?.canal ? JSON.parse(jsonrepair(item?.canal)) : [],
				pedido: JSON.parse(jsonrepair(item?.pedido))
			}));
			setPedidos(array);
			//console.log('peticionTraePedidos', array);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		peticionTraeEstados()
		peticionTraeAsesores()
		peticionTraeInteracciones()
		peticionTraePedidos()
		peticionTraeCampanas()
	}, [])


	const cambiarCheckCurso = (id_curso, check, item) => {
		let cursosActualesArray = []
		cursosActuales.map((curso) => {
			if (curso.id_curso === id_curso) {
				return cursosActualesArray.push({ ...curso, checked: check, virtual: true })
			}

			return cursosActualesArray.push(curso)
		})
		setCursosActuales(cursosActualesArray)
	}

	useEffect(() => { cargarCursos() }, [funcion])

	const cargarCursos = async () => {
		try {
			setDocumentos(registroSelect?.documentos ? JSON.parse(jsonrepair(registroSelect?.documentos)) : [])

			const resultadoPedidos = registroSelect?.cursos_interes ? JSON.parse(jsonrepair(registroSelect?.cursos_interes)) : []

			const cursosVirtuales = []

			Cursos.map((curso) => {
				const pedido = resultadoPedidos.find(item => item.id_curso == curso.id)
				let cursoPedido = {
					"id": getRandomInt(300),
					"activo": curso.activo,
					"tipo": "Curso",
					"nombre_producto": curso.nombre,
					"precio_producto": "0.00",
					"precio_rebajado": "0.00",
					"impuesto_producto": "Taxes",
					"categoria_producto": ["Todo", "cursos"],
					"atributos": [],
					"url_imagen": [{ "nombre_imagen": curso.imagen }],
					"id_curso": curso.id,
					"descripcion": curso.descripcion,
					"carga": 0,
					"cantidad": 1,
					"sumaImp": 0,
					"checked": pedido?.checked || false,
					"existe": pedido?.existe || false,
					"id_pedido": pedido ? pedido.id_pedido : null,
				}
				cursosVirtuales.push(cursoPedido)

			})

			cursosVirtuales.sort((a, b) => a.nombre_producto.length - b.nombre_producto.length);

			setCursosActuales(cursosVirtuales)
		} catch (error) {
			console.log(error)
		}

	}

	const peticionPut = async () => {

		const filtroCursos = cursosActuales.filter(curso => curso.checked)

		let fechaCad = moment(registro.fecha_cad).format("YYYY-MM-DD HH:mm:ss")
		const fechaHoy = moment(new Date()).format("YYYY-MM-DD");
		let { id, activo, usuario, clave, roll, nombre, email, pais, ciudad, estado, telefono, puntos, cursos, idAsesor } = registro

		if (usuario !== undefined && clave !== undefined && nombre !== undefined && roll !== undefined && email !== undefined && pais !== undefined && ciudad !== undefined && estado !== undefined && telefono !== undefined) {

			let f = new FormData()
			f.append('activo', activo)
			f.append('usuario', usuario.trim())
			f.append('clave', clave)
			f.append('claveNueva', claveNueva)
			f.append('roll', roll)
			f.append('nombre', nombre.trim())

			f.append('fecha_ins', fechaHoy)
			f.append('fecha_cad', fechaCad)
			f.append('pais', pais.trim())
			f.append('ciudad', ciudad.trim())
			f.append('estado', estado)
			f.append('telefono', telefono.trim())
			f.append('email', email.trim())
			f.append('cursos', JSON.stringify(cursos))
			f.append('puntos', puntos)
			f.append('asesor', idAsesor || null)
			f.append('cursos_interes', filtroCursos ? JSON.stringify(filtroCursos) : null)
			f.append('documentos', documentos ? JSON.stringify(documentos) : null)

			f.append('METHOD', 'PUT')

			axios.post(baseUrl, f, { params: { id: registro.id } })
				.then(response => {
					let dataNueva = data
					dataNueva.map(item => {
						if (item.id === id) {
							item.activo = activo
							item.usuario = usuario
							item.clave = response.data.clave
							item.roll = roll
							item.nombre = nombre
							item.telefono = telefono
						}
					})

					//setData(dataNueva)
					setRegistro({ activo: false })
					errores('Limpio', setError)
					setClaveNueva('')
					//setFuncion('ver')
					peticionTraeDatos()
				}).catch(error => {
					console.log(error);
				})


			const urlPedidos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'pedidos/'
			const pedido = cursosActuales.filter(curso => curso.checked)
			//actualizar pedido
			if (registro.temp) {
				let formData = new FormData()
				formData.append('pedido', JSON.stringify(pedido))
				formData.append('id', registro.temp)
				formData.append('METHOD', 'PUT')

				return await axios.post(urlPedidos, formData)
			} else {
				let idPedidoVirtual = ' ';
				const urlPedidos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'pedidos/'
				const pedido = cursosActuales.filter(curso => curso.checked && !curso.existe)

				const datosPago = {
					"subtotal": "0",
					"taxes": 0,
					"totalCargas": 0,
					"cargas": 0,
					"porcentajeImpuesto": 0,
					"canal": 'Activacion',
					"total": "0"
				}
				let formData = new FormData()
				formData.append('pedido', JSON.stringify(pedido))
				formData.append('datosPago', JSON.stringify(datosPago))
				formData.append('estado', "Aprobado")
				formData.append('total', "0")
				formData.append('cliente', JSON.stringify(registro))
				formData.append('id_stripe', " ")
				formData.append('usuario', registro.usuario)
				formData.append('fecha', moment().format("YYYY-MM-DD h:mm:ss"))
				formData.append('METHOD', 'POST')

				const resultado = await axios.post(urlPedidos, formData)


				idPedidoVirtual = resultado.data.id
				let f = new FormData()

				f.append('temp', idPedidoVirtual)
				f.append('id', registro.id)
				f.append('METHOD', 'PUT')

				return await axios.post(baseUrl, f)
			}

		} else errores('CampoVacio', setError)

	}

	const formatoSeparador = (number) => {
		const exp = /(\d)(?=(\d{3})+(?!\d))/g;
		const rep = '$1,';
		return `$${number?.toString().replace(exp, rep)}`;
	}
	const handleSubmit = async (e) => {
		e.preventDefault();

		let formData = new FormData()
		formData.append('estado', registro.estado_crm_id)
		formData.append('nota', registro.nota_crm)
		formData.append('id_cliente', registro.id)
		formData.append('id_usuario', cookies.get('id'))
		formData.append('fecha', moment().format("YYYY-MM-DD h:mm:ss"))
		formData.append('METHOD', 'POST')
		axios.post(urlInteracciones, formData).then(response => {
			peticionTraeInteracciones()
			setRegistro({ ...registro, nota_crm: '' })
		}).catch(e => console.log(e))
	}
	const eliminarRegistro = (dato, funcion) => e => {
		let formData = new FormData()
		formData.append('id_estado', dato.id)
		formData.append('id_cliente', dato.id_cliente)
		formData.append('METHOD', 'DELETE')
		axios.post(urlInteracciones, formData).then(response => {
			const respuesta = response.data;
			peticionTraeInteracciones()
			setRegistro({ ...registro, ...respuesta })
		}).catch(e => console.log(e))
	}


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ?
						<span className="error"> Error: {error.mensaje}</span> : null
					}
					<div><hr />

						<div className='row '>
							<div className='col-md-4'>
								<h3>{registro.nombre}</h3>
								<p className='Pmargen'><b>Usuario: </b>{registro.usuario}</p>
								<p className='Pmargen'><b>Roll: </b>{registro.roll}</p>
								<p className='Pmargen'><b>Fecha Membresía: </b>{registro.fecha_cad}</p>
								<p className='Pmargen'><b>Teléfono: </b>{registro.telefono}</p>
							</div>
							<div className='col-md-4'>
								<p className='Pmargen'><b>País: </b>{registro.pais}</p>
								<p className='Pmargen'><b>Estado: </b>{registro.estado}</p>
								<p className='Pmargen'><b>Ciudad: </b>{registro.ciudad}</p>
								<p className='Pmargen'><b>Dirección: </b>{registro.direccion}</p>
								<p className='Pmargen'><b>Asesor: </b>{registro.asesor}</p>
							</div>
							<div className='col-md-4'>
								<div className={`estados`} style={{ marginTop: 0, backgroundColor: registro.estado_color }}>
									{registro.estado_crm}
								</div>

								<p style={{ marginTop: 5, marginBottom: 0 }}><b>Asesor:</b></p>
								<select
									className="browser-default custom-select selectEstado"
									style={{ marginBottom: 5 }}
									name="estado"
									value={registro.asesor}
									onChange={e => {
										const selectedIndex = e.target.selectedIndex;
										const selectedOption = e.target.options[selectedIndex];
										const estadoColor = selectedOption.getAttribute('id-asesor');
										setRegistro({ ...registro, asesor: e.target.value, idAsesor: estadoColor });
									}}>
									{asesores.map((item) => {
										return <option key={item.nombre} value={item.nombre} id-asesor={item.id}>{item.nombre}</option>
									})}
									<option value={'Sin Asignar'} id-asesor={0}>Sin Asignar</option>
								</select>

								<span><b>Compras Totales:</b></span>
								<h3>{formatoSeparador(registro.total_pedidos)} </h3>

							</div>

						</div>

						<hr />

						<div className='col-md-12'>
							<h5>Documentos:</h5>
							<div className='row'>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="licenciaCheckbox"
											name="licencia"
											checked={documentos.licencia}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="licenciaCheckbox">¿Ya solicitó Licencia?</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="fotocopiasidCheckbox"
											name="fotocopiasid"
											checked={documentos.fotocopiasid}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="fotocopiasidCheckbox">Fotocopias de ID con foto</label>
									</div>
								</div>

								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="fotocopiasbachillerCheckbox"
											name="fotocopiasbachiller"
											checked={documentos.fotocopiasbachiller}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="fotocopiasbachillerCheckbox">Fotocopias certificado bachiller</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="fotocopiasnotariadaCheckbox"
											name="fotocopiasnotariada"
											checked={documentos.fotocopiasnotariada}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="fotocopiasnotariadaCheckbox">Fotocopias tradición notariada</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="documentomedicoCheckbox"
											name="documentomedico"
											checked={documentos.documentomedico}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="documentomedicoCheckbox">Documento médico</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="citasenviadasCheckbox"
											name="citasenviadas"
											checked={documentos.citasenviadas}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="citasenviadasCheckbox">Citas enviadas</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="usuariopassCheckbox"
											name="usuariopass"
											checked={documentos.usuarioPass}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="usuariopassCheckbox">Usuario y contraseña</label>
									</div>
								</div>
								<div className='col-4'>
									<div className="custom-control custom-checkbox custom-control-inline">
										<input
											className="custom-control-input"
											type="checkbox"
											id="pagoextraCheckbox"
											name="pagoextra"
											checked={documentos.pagoextra}
											onChange={handleCheckboxChange}
										/>
										<label className="custom-control-label" htmlFor="pagoextraCheckbox">⁠Pago extrainstitucionales</label>
									</div>
								</div>
							</div>
						</div>


						<hr />
						<>
							{funcion === 'crear' && <div className='col-md-12'>
								<div>
									<h5>Seleccione Cursos de Interes:</h5>
									<div className='row'>
										{cursosActuales.map((item, index) => {
											if (item.activo === 'true') {
												return (
													<div className='col-4'>
														<div className="custom-control custom-checkbox custom-control-inline" key={index}>
															<input type="checkbox" className="custom-control-input" name={item.id_curso} id={item.nombre_producto}
																onChange={(e) => cambiarCheckCurso(item.id_curso, e.target.checked, item)} checked={item.checked} />
															<label className="custom-control-label" htmlFor={item.nombre_producto}>{item.nombre_producto}</label>
														</div>
													</div>
												)
											}
										})
										}
									</div>
								</div>
							</div>}

							{funcion === 'editar' && cursosActuales.length > 0 && <div className='col-md-12'>
								<div>
									<h5>Seleccione Cursos de Interes:</h5>
									<div className='row'>
										{cursosActuales.map((item, index) => {
											if (item.activo === 'true') {
												return (
													<div className='col-4'>
														<div className="custom-control custom-checkbox custom-control-inline" key={index}>
															<input type="checkbox" className="custom-control-input" name={item.id_curso} id={item.nombre_producto}
																onChange={(e) => cambiarCheckCurso(item.id_curso, e.target.checked, item)} checked={item.checked} />
															<label className="custom-control-label" htmlFor={item.nombre_producto}>{item.nombre_producto}</label>
														</div>
													</div>
												)
											}
										})
										}
									</div>
								</div>
							</div>}

							<hr />
							<form onSubmit={handleSubmit}>
								<div className='col-md-12 row'>
									<div className='col-md-12'><h4>Historial de Interacciones:</h4></div>
									<div className='col-md-3'>
										<label htmlFor="exampleFormControlTextarea1">Crea una nueva interacción:</label>
										<select className="browser-default custom-select selectEstado"
											style={{ marginBottom: 5 }}
											name="estado"
											id="estado"
											required
											value={registro.estado_crm}
											onChange={e => {
												const selectedIndex = e.target.selectedIndex;
												const selectedOption = e.target.options[selectedIndex];
												const estadoColor = selectedOption.getAttribute('data-color');
												const id = selectedOption.getAttribute('id');
												setRegistro({ ...registro, estado_crm: e.target.value, estado_color: estadoColor, estado_crm_id: id });
											}}>
											<option value=''>Seleccione...</option>
											{estados.map((item) => {
												return <option key={item.nombre} value={item.nombre} data-color={item.color} id={item.id}>{item.nombre}</option>
											})}
										</select>
										<div className="form-group">
											<textarea
												className="form-control"
												id="nota"
												name="nota"
												rows="3"
												required
												value={registro.nota_crm}
												placeholder="Escribe una nota"
												onChange={(e) => setRegistro({ ...registro, nota_crm: e.target.value })}
											></textarea>
										</div>
										<div className="col text-center">
											<button
												type='submit'
												className="btn boton_estandar"
											>{`Subir Estado`}
											</button>
										</div>
									</div>
									<div className='col-md-9'>
										<VerInteracciones data={interacciones} seleccionaRegistro={eliminarRegistro} />
									</div>
								</div>
							</form>

							<div className="col-md-12">
								<h5>Campañas de este usuario:</h5>
								<VerCampanasCliente data={campanas} />
							</div>


							{funcion === 'editar' && pedidos.length > 0 &&
								<>
									<hr />
									<div className='col-md-12 editar-usuario' style={{ maxHeight: 300, overflowY: 'scroll' }}>
										<h5>Compras y Activaciones:</h5>
										<div className='editar-usuario-comprados' >

											{pedidos.map((pedido) =>
												<div style={{ display: 'flex' }} className='editar-usuario-comprados-container' key={pedido.id}>
													<div style={{ flex: 1 }}>
														<span><ReactMoment format="YYYY-MM-DD">{pedido.fecha}</ReactMoment></span>
													</div>
													<div style={{ flex: 4, maxHeight: 300 }}>

														<span><b>Productos:</b></span>
														{pedido.pedido.map(item => {
															return (<div>
																<span><td><div className="img_pro_crm"><img src={`${urlProductos}${item.url_imagen[0].nombre_imagen}`} /></div></td></span>
																<span>{item.nombre_producto}, Cant: {item.cantidad}, total: ${item.precio_producto}</span>
															</div>)
														})}

													</div>
													<div style={{ flex: 1 }}>
														<span><b>Pedido:</b> {pedido.id}</span>
													</div>
													<div style={{ flex: 1 }}>
														<span><b>total: </b>${pedido.total}</span>
													</div>
													<div style={{ flex: 1 }}>
														<span><b>{pedido.tipo} por: {pedido.canal}</b></span>
													</div>
												</div>
											)}
										</div>
									</div>
								</>
							}

							<hr />

						</>

						<br />
						<div className="col text-center">
							<button
								onClick={peticionPut}
								className="btn boton_estandar"
							>{`Actualizar Cliente`}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div >
	)
}

export default VerCliente